import { Injectable } from '@angular/core';
import { Http, RequestOptions, URLSearchParams, ResponseContentType, RequestMethod, Headers } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import * as moment from 'moment';
import {saveAs as importedSaveAs} from "file-saver";
import { environment } from './../../environments/environment';

@Injectable()
export class CopertinarioService {

  constructor(private http: Http) { }

  uploadEans(fileToUpload: any) {
    let input = new FormData();
    input.append("file", fileToUpload);
    console.log(fileToUpload)
    let options = new RequestOptions({ responseType: ResponseContentType.Json });
    return this.http.post(environment.server.url + '/copertinario/uploadEans', input, options)
  }

  createPDFCopertinario(wm) {
    let options = new RequestOptions({ responseType: ResponseContentType.Blob,  method: RequestMethod.Post });
    let opt = {
      jrxmlName: wm.jrxmlName,
      fontSize: wm.fontSize,
      fontName: wm.fontName,
      przRed: wm.przRed,
      barcode: wm.barcode,
      eans: wm.eans,
      footerRCaption: wm.footerRCaption,
      imgHeader: wm.imgHeader,
      publisher: environment.publisher
    }
    return this.http.post(environment.copertinario.make, opt, options)
  }

  readCopertinario(): Observable<any> {
    return this.http.post(environment.server.url + '/copertinario/copertinario', {})
      .map(response => response.json())
  }

  persist(wmodel: any) {
    console.log('copertinario persist', wmodel)
    return this.http.post(environment.server.url + '/copertinario/persist', { wmodel: wmodel })
      .map(response => response.json())
      .catch((err) => Observable.throw(err))
  }

  private handleError(error: Response | any) {
    console.error(error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/copertinario.service.ts